import { BodyM, Caption, Description, Small } from '@casavo/base-ui'
import cn from 'classnames'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import React from 'react'

import { TokenSupport } from '@/design-lib/base-ui/Typography'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ellipsis, flexCenter, gap, paddingBottom, rotate90 } from '@/shared-styles/styles.css'
import { MapPoi, PoiCategory, PoiType } from '@/types/poi'
import { getPoiCategoryFromType } from '@/utils/points-of-interest'

import { cardPoi, cardPoiFooter } from './index.css'

type Props = {
  openMap: (p: PoiCategory) => void
  poi: MapPoi
}

export const CardPoi: React.FC<Props> = ({ openMap, poi: { distance, name, poiType } }) => {
  const { t } = useTranslation()

  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  const poiCategory = getPoiCategoryFromType(poiType as PoiType)
  const icon = `${poiCategory.toLocaleLowerCase()}-icon`

  return (
    <button className={cardPoi} onClick={() => openMap(poiCategory)}>
      <div className={cn(flexCenter, gap.s, paddingBottom.s)}>
        <img alt="" data-testid={icon} height="21" src={`${imageBasePath}/images/poi/${icon}.svg`} />

        <BodyM>{t(`listing-detail:${poiCategory}.poi_nearby_card_title`)}</BodyM>
      </div>
      <div className={paddingBottom['s-m']}>
        <Description className={paddingBottom.xs} color="greyscale500">
          <Trans
            components={[
              <strong key="0" />,
              <br
                key="1"
                className={sprinkles({
                  display: { desktop: 'block', mobile: 'none' },
                })}
              />,
            ]}
            i18nKey={`listing-detail:${poiCategory}.poi_nearby_card_distance`}
            values={{ distance }}
          />
        </Description>

        <Caption className={ellipsis} color="greyscale400">
          {name ? name : t(`listing-detail:${poiCategory}.${poiType}_label`)}
        </Caption>
      </div>
      <div className={cardPoiFooter}>
        <Small strong>
          <TokenSupport>{`listing-detail:${poiCategory}.poi_nearby_card_all`}</TokenSupport>
        </Small>
        <img alt="" className={rotate90} height={16} src={`${imageBasePath}/images/chevron-dark.svg`} />
      </div>
    </button>
  )
}
